import React from 'react';

interface PasswordRequirementsProps {
  className?: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  className = '',
}) => {
  return (
    <div className={`w-full mt-1 ${className}`}>
      <p className="font-thin text-sm text-[#FDB528] bg-[#FFF6E5] rounded-md px-4 py-2">
        Ensure that these requirements are met: <br />
        Minimum 8 characters long, at least one uppercase letter and at least
        one symbol.
      </p>
    </div>
  );
};

export default PasswordRequirements;
